// packages import
import { useSearchParams } from "react-router-dom"
// component block
import { AuthLayout } from "../../../components/auth/Layout"
import { ResetPasswordForm } from "../../../components/auth/ResetPasswordForm"
// others
import { RESET_PASSWORD, SET_PASSWORD_SUBTITLE } from "../../../constants"

export const ResetPassword = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return (
    <AuthLayout title={RESET_PASSWORD} subTitle={SET_PASSWORD_SUBTITLE}>
      <ResetPasswordForm token={token || ""} />
    </AuthLayout>
  )
}